(function() {
  function getScriptPath() {
    var scriptElem = $('#js-drive-bundle');
    var path = '';

    if (scriptElem.length > 0) {
      path = scriptElem.data('driveurl');
    }

    return path;
  }

  var driveurl = getScriptPath();

  var supportSvg = !!document.createElementNS && /SVGForeignObject/.test(document.createElementNS('http://www.w3.org/2000/svg', 'foreignObject').toString());

  if(!supportSvg) {
    loadJS( driveurl + '/drive2/js/pollyfills/svg4everybody.legacy.min.js', function() {
      svg4everybody();
    });
  }
}());